export type ConversationObjectType = "party" | "contract" | "damage" | "risk";

export const CONVERSATION_NEW_ID = "new";
